import React from 'react';
import { Modal, Box, Typography, Button, Divider, Chip, List, ListItem, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LanguageIcon from '@mui/icons-material/Language';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'; // New icon for benefits

const style = (theme) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '95%', sm: 600, md: 800 },
    maxHeight: '90vh',
    overflowY: 'auto',
    bgcolor: theme.palette.background.paper,
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
});

export const ResourceDetailModal = ({ open, handleClose, resource }) => {
    const theme = useTheme();

    if (!resource) return null;

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="resource-detail-title"
            aria-describedby="resource-detail-description"
        >
            <Box sx={style(theme)}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography id="resource-detail-title" variant="h4" component="h2" sx={{ fontWeight: 700, color: theme.palette.primary.dark }}>
                        {resource.title}
                    </Typography>
                    <Button onClick={handleClose}><CloseIcon /></Button>
                </Box>
                
                <Box sx={{ mb: 2 }}>
                    {resource.tags.map(tag => (
                        <Chip key={tag} label={tag} size="small" sx={{ mr: 1, mb: 1, bgcolor: theme.palette.secondary.light }} />
                    ))}
                    <Chip label={resource.type} size="small" variant="outlined" sx={{ mr: 1, mb: 1 }} />
                </Box>

                <Typography variant="body1" sx={{ mb: 3 }}>
                    {resource.description}
                </Typography>

                <Divider sx={{ my: 2 }} />

                {/* Contact Information Section */}
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Contact Information</Typography>
                <List dense>
                    {resource.address && (
                        <ListItem><ListItemIcon><LocationOnIcon color="primary" /></ListItemIcon><ListItemText primary={resource.address} /></ListItem>
                    )}
                    {resource.phone && (
                        <ListItem><ListItemIcon><PhoneIcon color="primary" /></ListItemIcon><ListItemText primary={`Call: ${resource.phone}`} /></ListItem>
                    )}
                    {resource.website && (
                        <ListItem><ListItemIcon><LanguageIcon color="primary" /></ListItemIcon><ListItemText primary="Visit Website" secondary={resource.website} /><Button size="small" href={resource.website} target="_blank">Go</Button></ListItem>
                    )}
                    {resource.email && (
                        <ListItem><ListItemIcon><EmailIcon color="primary" /></ListItemIcon><ListItemText primary={`Email: ${resource.email}`} /></ListItem>
                    )}
                </List>
                
                {/* 🛑 NEW: Benefits and Perks Section (Conditional Rendering) */}
                {resource.benefits && resource.benefits.length > 0 && (
                    <>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: theme.palette.secondary.main }}>
                            Benefit Coverage & Perks
                        </Typography>
                        {resource.benefits.map((benefit, index) => (
                            <Box key={index} sx={{ mb: 3, p: 2, bgcolor: theme.palette.mode === 'light' ? '#f5f5f5' : '#1e1e1e', borderRadius: 1 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1, color: theme.palette.primary.main }}>
                                    {benefit.name}
                                </Typography>
                                <List dense disablePadding>
                                    {benefit.perks.map((perk, perkIndex) => (
                                        <ListItem key={perkIndex} disableGutters>
                                            <ListItemIcon sx={{ minWidth: 30 }}><CheckCircleOutlineIcon fontSize="small" color="secondary" /></ListItemIcon>
                                            <ListItemText primary={perk} />
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                        ))}
                    </>
                )}
                {/* End of NEW Section */}

                <Divider sx={{ my: 2 }} />
                
                <Box sx={{ mt: 3, textAlign: 'right' }}>
                     <Button 
                         variant="contained" 
                         color="primary" 
                         onClick={handleClose}
                         startIcon={<CloseIcon />}
                     >
                         Close Details
                     </Button>
                </Box>
            </Box>
        </Modal>
    );
};